/**
 * 装扮商城
 */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { connect } from 'react-redux';
import { message, Modal, Tabs } from 'antd';
import Scrollbar from 'react-scrollbars-custom';
import store from '../../store/store';
import HTTP from '../../script/service';
import ListItem from './ListItem/ListItem';
import ConfrimIframeModal from '../iframModal/ConfrimIframeModal';
import { DDEmpty, DDLoading } from '../globalPageStatus';
import Utils from '../../script/util';
import { cloneDeep } from 'lodash-es';
import './index.scss';
import BuyModal from './BuyModal/BuyModal';
import RenderTabBar from '../RenderTabBar';

const DressUpMallModal = ({ base }) => {
  const { dressUpMallVisible, rootConfig, uid } = base;
  const confirmElement = useRef(null);
  const buyModalElement = useRef(null);

  const [loading, setLoading] = useState(true); // 加载中
  const [allPropType, setAllPropType] = useState([]); // 道具分类数据
  const [listType, setListType] = useState(null); // 当前分类的 listType
  const [isHotData, setIsHotData] = useState(false); // 热门分类是否有数据
  const [hotData, setHotData] = useState([]); // 热门分类数据
  const [data, setData] = useState({}); // 分类下的数据

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (dressUpMallVisible && !allPropType?.length) {
      queryAllPropBusinessList();
    }
  }, [dressUpMallVisible, allPropType]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (listType === 1) {
      queryAllHotPropList();
    }
  }, [listType]);

  // 获取道具商城数据
  const queryAllPropBusinessList = () => {
    HTTP._query_all_prop_list_v3({ uid })
      .then((res) => {
        if (res?.code === 200) {
          const data = res.data;
          const firstListType = data[0].listType; // 第一个数组 listype 1：热门 2：普通 3：弹幕
          setAllPropType(data);
          setListType(firstListType);

          if (firstListType !== 1) {
            setLoading(false);
          }
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // 获取热门分类下的商品
  const queryAllHotPropList = () => {
    HTTP._query_all_hot_prop_list({ uid })
      .then((res) => {
        if (res?.code === 200) {
          const isHotData = res.data.some(
            (item) => item.list && item.list.length
          );
          setIsHotData(isHotData);
          setHotData(res.data);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // 切换一级分类
  const mallTabsOneChange = (type) => {
    const find = allPropType.find((n) => n.id == type);
    if (find?.list?.length) {
      const first = find.list[0];
      queryPropBusinessList(first.id);
    }
  };
  // 获取分类下的商品
  const queryPropBusinessList = (categoryId) => {
    if (categoryId == null) {
      message.error('数据异常，请稍后重试');
      return;
    }
    if (!!data[categoryId]?.length) return;
    setLoading(true);
    setTimeout(() => {
      const params = { uid, categoryId };
      HTTP._query_prop_business_list(params)
        .then((res) => {
          if (res?.code === 200) {
            const copyData = cloneDeep(data);
            copyData[categoryId] = res?.data || [];
            setData(copyData);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }, 100);
  };

  // 隐藏弹窗
  const hideModal = () => {
    setData({});
    setListType(null);
    setAllPropType([]);
    setHotData([]);
    setIsHotData(false);
    store.dispatch({
      type: 'change_dress_up_mall_visible',
      data: { dressUpMallVisible: false },
    });
  };
  // 购买弹幕数量
  const handleBuyPop = () => {
    buyModalElement.current && buyModalElement.current.showModal(null, true);
  };
  // 打开装扮说明
  const openRemark = () => {
    let url = rootConfig.mobilePath + '/dressup/index.html';
    let title = '装扮说明';

    confirmElement.current &&
      confirmElement.current.showModal({
        url: url,
        title: title,
        scrolling: 'no',
        width: '750px',
        height: '490px',
      });
  };
  const tabLabelContent = useCallback((tab) => {
    if (tab.listType === 1) {
      return (
        <div className="hot-content">
          <i className="icon hot" />
          <span>推荐</span>
        </div>
      );
    }
    return (
      <>
        <i
          className="icon"
          style={{
            backgroundImage: `url(${Utils.transImgUrl(tab.icon, '32x32')})`,
          }}
        />
        <span>{tab.categoryName}</span>
      </>
    );
  }, []);
  const tabChildrenContent = useCallback(
    (tab) => {
      if (tab.listType === 1) {
        return (
          <div className="ant-tabs-tabpane-active hot-content">
            {isHotData && (
              <p className="question-box" onClick={openRemark}>
                <i className="icon-question" />
                <span>装扮说明</span>
              </p>
            )}
            {isHotData ? (
              <Scrollbar>
                {hotData.map((child, index) =>
                  child.list && child.list.length ? (
                    <div className="dress-item" key={child.id}>
                      <div className={`item-head item-head-${child.id}`}>
                        <p className="title">{child.categoryName}</p>
                      </div>
                      <div className="item-childs">
                        {child.list.map((childItem) => (
                          <ListItem
                            base={base}
                            key={childItem.id}
                            isName
                            items={childItem}
                          />
                        ))}
                      </div>
                    </div>
                  ) : null
                )}
              </Scrollbar>
            ) : (
              !loading && (
                <DDEmpty
                  description="该分类下暂无商品"
                  className="genera-list-empty"
                />
              )
            )}
          </div>
        );
      }
      if (tab?.list?.length) {
        return (
          <Tabs
            className="tabs-tow"
            onTabClick={queryPropBusinessList}
            items={tab.list.map((n) => ({
              key: n.id.toString(),
              label: n.categoryName,
              children: (
                <>
                  {tab.listType === 3 ? ( // 弹幕
                    <li
                      className="btn-buy daidai-btn-primary"
                      onClick={handleBuyPop}
                    >
                      <i className="icon-dan"></i>
                      <span>购买弹幕</span>
                    </li>
                  ) : (
                    <p className="question-box" onClick={openRemark}>
                      <i className="icon-question" />
                      <span>装扮说明</span>
                    </p>
                  )}
                  <Scrollbar>
                    {data[n.id]?.length
                      ? data[n.id].map((item) => (
                          <ListItem key={item.id} base={base} items={item} />
                        ))
                      : !loading && (
                          <DDEmpty
                            description="该分类下暂无商品"
                            className="genera-list-empty"
                          />
                        )}
                  </Scrollbar>
                </>
              ),
            }))}
          />
        );
      }

      return null;
    },
    [data, isHotData, hotData]
  );
  const renderTabItem = useMemo(() => {
    if (!allPropType?.length) return [];

    return allPropType.map((tab) => ({
      key: tab.id.toString(),
      label: tabLabelContent(tab),
      children: tabChildrenContent(tab),
    }));
  }, [allPropType, hotData, data]);
  
  return (<>
    <Modal
      open={dressUpMallVisible}
      className="dress-up-mall-modal"
      width={1223}
      title={null}
      closable={false}
      centered
      footer={null}
    >
      <DDLoading status={loading}>
        <div className="mall-header">
          <h2 className="title">装扮商城</h2>
          <span className="icon-close" onClick={hideModal} />
        </div>
        <div className="mall-nav-wrap">
          <Tabs
            className="mall-tabs"
            animated={false}
            onTabClick={mallTabsOneChange}
            renderTabBar={RenderTabBar}
            items={renderTabItem}
          />
        </div>
      </DDLoading>

    </Modal>
    {/* 装扮说明 */}
    <ConfrimIframeModal wrappedComponentRef={confirmElement} />
    {/* 购买弹幕 */}
    <BuyModal wrappedComponentRef={buyModalElement} base={base} />
  </>
  );
};

export default connect((store) => ({ base: store }))(DressUpMallModal);
